// extracted by mini-css-extract-plugin
module.exports = {"link":"_1ehDF0","shine-lines":"_240j-o"};